import React, { useState } from 'react';
import {EditOutlined} from '@ant-design/icons';
import { Button, Modal, Form, Input, Select } from 'antd';
const {Option} = Select
const EmployeeUpdateForm = ({ visible, onCreate, onCancel, record }) => {
  
  let employee = record
  const [form] = Form.useForm();
  const [employeeID]=useState(employee.EmployeeID)
  const [employeeName]=useState(employee.EmployeeName)
  const [employeePhoto]=useState(employee.EmployeePhoto)
  const [employeePhone]=useState(employee.EmployeePhone)
  const [employeeEmail]=useState(employee.EmployeeEmail)
  const [employeeStatus]=useState(employee.EmployeeStatus)
  
  return (
    <Modal
      visible={visible}
      title="Update Employee"
      okText="Update"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}
    >
      <Form
        form={form}
        layout="vertical"
        name="EmployeeUpdate"
        initialValues={{
            EmployeeID:employeeID,
            EmployeeName:employeeName,
            EmployeePhoto:employeePhoto,
            EmployeePhone:employeePhone,
            EmployeeEmail:employeeEmail,
            EmployeeStatus:employeeStatus,
        }}
      >
        <Form.Item
          name="EmployeeID"
          label="Employee ID"
        >
            <Input disabled/>
        </Form.Item>
        <Form.Item
          name="EmployeeName"
          label="Employee Name"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="EmployeePhoto"
          label="Employee Photo"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="EmployeeEmail"
          label="Employee Email"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="EmployeePhone"
          label="Employee Phone"
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="EmployeeStatus"
          label="Employee Status"
        >
          <Select>
            <Option value={1}>Employed</Option>
            <Option value={0}> Unemployed</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const EmployeeUpdate = (props) => {

  const [visible, setVisible] = useState(false);
  const onCreate = (values) => {
    props.updateEmployee(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}

        icon={<EditOutlined />}
      >
        
      </Button>
      <EmployeeUpdateForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
        record={props.record}
      />
    </div>
  );
};

export default EmployeeUpdate